import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import DateRangeWithConstants from '../DateRangeWithConstants';

const Activity = ({ data }) => {
  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Registration period'}
        field={'activity.regPeriod'}
        type={({ value }) => <DateRangeWithConstants period={value} />}
      />
      <DescriptionItem
        label={'Last activity period'}
        field={'activity.visitPeriod'}
        type={({ value }) => <DateRangeWithConstants period={value} />}
      />
      <DescriptionItem
        label={'Inactive since'}
        field={'activity.inactiveSinceDate'}
        type={'date'}
        template={'LL'}
        timeZone={'utc'}
      />
      <DescriptionItem
        label={'Users level'}
        field={'activity.userLevel'}
        type={'decimalRange'}
        valueParser={'minMaxToStringArray'}
      />
      <DescriptionItem
        label={'Days offline'}
        field={'activity.daysOffline'}
        type={'decimalRange'}
        valueParser={'minMaxToStringArray'}
      />
      <DescriptionItem
        label={'Seniority days'}
        field={'activity.seniorityDays'}
        type={'decimalRange'}
        valueParser={'minMaxToStringArray'}
      />
      <DescriptionItem
        label={'RE Counter'}
        field={'activity.reCounter'}
        type={'decimalRange'}
        valueParser={'minMaxToStringArray'}
      />
    </DescriptionList>
  );
};

export default Activity;
